import React from "react";
import {
  X,
  Download,
  MessageSquare,
  FolderTree,
  Trash2,
  RotateCcw,
  CheckCircle,
  Clock,
  XCircle,
} from "lucide-react";
import chatIcon from "../../../assets/UserIcons/NewChatIcon2.svg";

export const RepoFloatingActions = ({
  selectedCount,
  hasSelectedFolder,
  canModifySelectedItems,
  allSelectedPersonalItems,
  allSelectedDeletedPersonalItems,
  role,
  selectedFileCount,
  showChatWithSelectedFiles,
  hideDownloadForSelected,
  onClearSelection,
  onBulkDownload,
  onChatSelectedFiles,
  onOpenMoveModal,
  onOpenDeleteModal,
  onBulkRestore,
  onBulkApprovalStatus,
  hideApprovalForSelected,
}) => {
  if (selectedCount === 0) return null;
  const hasActions =
    (!hasSelectedFolder && !hideDownloadForSelected) ||
    showChatWithSelectedFiles ||
    canModifySelectedItems ||
    allSelectedDeletedPersonalItems ||
    allSelectedPersonalItems ||
    (role === "admin" &&
      !hasSelectedFolder &&
      selectedFileCount > 0 &&
      !hideApprovalForSelected);

  return (
    <div className="repo-floating-actions">
      <div className="repo-floating-left">
        <button
          className="repo-floating-close"
          onClick={onClearSelection}
          title="Clear selection"
        >
          <X size={18} className="icon-image" />
        </button>
        <span className="repo-floating-count">{selectedCount} selected</span>
      </div>
      <div className="repo-floating-right">
        {!hasActions ? (
          <span className="ak-text-lg">
            No actions to perform
          </span>
        ) : (
          <>
            {!hasSelectedFolder && !hideDownloadForSelected && (
              <button
                className="repo-floating-btn"
                onClick={onBulkDownload}
                title="Download"
              >
                <Download size={18} className="icon-image" />
              </button>
            )}
            {showChatWithSelectedFiles && (
              <button
                className="repo-floating-btn"
                onClick={onChatSelectedFiles}
                title="Chat with selected files"
              >
                <img
                  src={chatIcon}
                  alt="Chat"
                  width={18}
                  height={18}
                  className="icon-image"
                  style={{ width: "18px", height: "18px" }}
                />
                {/* <MessageSquare size={18} /> */}
              </button>
            )}
            {canModifySelectedItems && (
              <button
                className="repo-floating-btn"
                onClick={onOpenMoveModal}
                title="Move"
              >
                <FolderTree size={18} className="icon-image" />
              </button>
            )}
            {allSelectedDeletedPersonalItems ? (
              <button
                className="repo-floating-btn"
                onClick={onBulkRestore}
                title="Restore"
                style={{ color: "#4ade80" }}
              >
                <RotateCcw size={18} className="icon-image" />
              </button>
            ) : allSelectedPersonalItems ? (
              <button
                className="repo-floating-btn"
                onClick={onOpenDeleteModal}
                title="Delete"
                style={{ color: "var(--danger-color)" }}
              >
                <Trash2 size={18} className="icon-image" />
              </button>
            ) : null}

            {role === "admin" &&
              !hasSelectedFolder &&
              selectedFileCount > 0 &&
              !hideApprovalForSelected && (
                <>
                  <div
                    style={{
                      width: "1px",
                      height: "24px",
                      background: "rgba(255,255,255,0.2)",
                      margin: "0 4px",
                    }}
                  />
                  <button
                    className="repo-floating-btn"
                    onClick={() => onBulkApprovalStatus("approved")}
                    title="Approve"
                    style={{ color: "#4ade80" }}
                  >
                    <CheckCircle size={18} className="icon-image" />
                  </button>
                  <button
                    className="repo-floating-btn"
                    onClick={() => onBulkApprovalStatus("pending")}
                    title="Set Pending"
                    style={{ color: "#fbbf24" }}
                  >
                    <Clock size={18} className="icon-image" />
                  </button>
                  <button
                    className="repo-floating-btn"
                    onClick={() => onBulkApprovalStatus("rejected")}
                    title="Reject"
                    style={{ color: "#f87171" }}
                  >
                    <XCircle size={18} className="icon-image" />
                  </button>
                </>
              )}
          </>
        )}
      </div>
    </div>
  );
};
